export default __webpack_public_path__ + "static/media/pictogramBeaconAlert48.da21d74a.svg";